import { render, staticRenderFns } from "./t-loader.vue?vue&type=template&id=06063d0f"
import script from "./t-loader.vue?vue&type=script&lang=js"
export * from "./t-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports